var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "ibox-title" }),
    _vm._v(" "),
    _c("div", { attrs: { id: "popup" } }, [
      _c(
        "p",
        {
          staticClass: "report_tit",
          staticStyle: {
            "font-size": "26px",
            "font-weight": "bold",
            "text-align": "center",
            margin: "10px 0"
          }
        },
        [_vm._v(_vm._s(_vm.popupList.hospital) + "儿童体检报告单")]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticStyle: {
            display: "block",
            "text-align": "right",
            padding: "10px",
            "border-bottom": "4px solid #333"
          }
        },
        [_vm._v("体检日期：" + _vm._s(_vm.popupList.checkDate))]
      ),
      _vm._v(" "),
      _c("p", { staticStyle: { padding: "10px 0 10px 30px", margin: "0" } }, [
        _vm._v(
          _vm._s(_vm.popupList.gardenName) +
            "，" +
            _vm._s(_vm.popupList.childName) +
            "的家长，您的孩子本次体检结果如下："
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "cheitem_box",
          staticStyle: {
            padding: "10px 30px",
            color: "#333",
            "border-top": "1px solid #727070",
            overflow: "hidden"
          }
        },
        [
          _c(
            "span",
            {
              staticStyle: {
                width: "calc(50% - 5px)",
                display: "inline-block",
                height: "30px",
                "line-height": "30px"
              }
            },
            [_vm._v("身高（cm）：" + _vm._s(_vm.popupItem.height))]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                width: "calc(50% - 5px)",
                display: "inline-block",
                height: "30px",
                "line-height": "30px"
              }
            },
            [_vm._v("身高评价：" + _vm._s(_vm.popupItem.heightComment))]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                width: "calc(50% - 5px)",
                display: "inline-block",
                height: "30px",
                "line-height": "30px"
              }
            },
            [_vm._v("体重（kg）：" + _vm._s(_vm.popupItem.weight))]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                width: "calc(50% - 5px)",
                display: "inline-block",
                height: "30px",
                "line-height": "30px"
              }
            },
            [_vm._v("体重评价：" + _vm._s(_vm.popupItem.weightComment))]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                width: "calc(50% - 5px)",
                display: "inline-block",
                height: "30px",
                "line-height": "30px"
              }
            },
            [_vm._v("体重指数（%）：" + _vm._s(_vm.popupList.weightPercent))]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                width: "calc(50% - 5px)",
                display: "inline-block",
                height: "30px",
                "line-height": "30px"
              }
            },
            [_vm._v("肥胖指数（%）：" + _vm._s(_vm.popupList.fatPercent))]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                width: "calc(50% - 5px)",
                display: "inline-block",
                height: "30px",
                "line-height": "30px"
              }
            },
            [_vm._v("BMI：" + _vm._s(_vm.popupList.bmiValue))]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                width: "calc(50% - 5px)",
                display: "inline-block",
                height: "30px",
                "line-height": "30px"
              }
            },
            [_vm._v("综合评价：" + _vm._s(_vm.popupList.overallComment))]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                width: "calc(50% - 5px)",
                display: "inline-block",
                height: "30px",
                "line-height": "30px"
              }
            },
            [_vm._v("心肺：" + _vm._s(_vm.popupItem.lung))]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                width: "calc(50% - 5px)",
                display: "inline-block",
                height: "30px",
                "line-height": "30px"
              }
            },
            [_vm._v("肝脾：" + _vm._s(_vm.popupItem.liver))]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                width: "calc(50% - 5px)",
                display: "inline-block",
                height: "30px",
                "line-height": "30px"
              }
            },
            [_vm._v("皮肤：" + _vm._s(_vm.popupItem.skin))]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                width: "calc(50% - 5px)",
                display: "inline-block",
                height: "30px",
                "line-height": "30px"
              }
            },
            [_vm._v("外生殖器：" + _vm._s(_vm.popupItem.wszq))]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "cheitem_box",
          staticStyle: {
            padding: "10px 30px",
            color: "#333",
            "border-top": "1px solid #727070",
            overflow: "hidden"
          }
        },
        [
          _c(
            "span",
            {
              staticStyle: {
                width: "calc(50% - 5px)",
                display: "inline-block",
                height: "30px",
                "line-height": "30px"
              }
            },
            [_vm._v("左眼视力：" + _vm._s(_vm.popupItem.LSight))]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                width: "calc(50% - 5px)",
                display: "inline-block",
                height: "30px",
                "line-height": "30px"
              }
            },
            [_vm._v("左眼评价：" + _vm._s(_vm.popupItem.LComment))]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                width: "calc(50% - 5px)",
                display: "inline-block",
                height: "30px",
                "line-height": "30px"
              }
            },
            [_vm._v("右眼视力：" + _vm._s(_vm.popupItem.RSight))]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                width: "calc(50% - 5px)",
                display: "inline-block",
                height: "30px",
                "line-height": "30px"
              }
            },
            [_vm._v("右眼评价：" + _vm._s(_vm.popupItem.RComment))]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                width: "calc(50% - 5px)",
                display: "inline-block",
                height: "30px",
                "line-height": "30px"
              }
            },
            [_vm._v("视力筛查：" + _vm._s(_vm.popupItem.SLSC))]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                width: "calc(50% - 5px)",
                display: "inline-block",
                height: "30px",
                "line-height": "30px"
              }
            },
            [_vm._v("鼻：" + _vm._s(_vm.popupItem.NOSE))]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                width: "calc(50% - 5px)",
                display: "inline-block",
                height: "30px",
                "line-height": "30px"
              }
            },
            [_vm._v("左耳：" + _vm._s(_vm.popupItem.LEar))]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                width: "calc(50% - 5px)",
                display: "inline-block",
                height: "30px",
                "line-height": "30px"
              }
            },
            [_vm._v("右耳：" + _vm._s(_vm.popupItem.REar))]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                width: "calc(50% - 5px)",
                display: "inline-block",
                height: "30px",
                "line-height": "30px"
              }
            },
            [_vm._v("牙齿数：" + _vm._s(_vm.popupItem.teethNum))]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                width: "calc(50% - 5px)",
                display: "inline-block",
                height: "30px",
                "line-height": "30px"
              }
            },
            [_vm._v("龋齿数：" + _vm._s(_vm.popupItem.Caries))]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                width: "calc(50% - 5px)",
                display: "inline-block",
                height: "30px",
                "line-height": "30px"
              }
            },
            [_vm._v("血红蛋白：" + _vm._s(_vm.popupItem.HB))]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "cheitem_box",
          staticStyle: {
            padding: "10px 30px",
            color: "#333",
            "border-top": "1px solid #727070",
            overflow: "hidden"
          }
        },
        [
          _c(
            "span",
            {
              staticStyle: {
                width: "calc(50% - 5px)",
                display: "inline-block",
                height: "30px",
                "line-height": "30px"
              }
            },
            [_vm._v("其他：" + _vm._s(_vm.popupItem.qtfz))]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "cheitem_box",
          staticStyle: {
            padding: "10px 30px",
            color: "#333",
            "border-top": "1px solid #727070",
            overflow: "hidden"
          }
        },
        [
          _c("p", { staticStyle: { margin: "5px 0" } }, [
            _vm._v("检查结果：" + _vm._s(_vm.popupList.checkResult))
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "span",
              { staticStyle: { "line-height": "33px", float: "left" } },
              [_vm._v("医生意见：")]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticStyle: {
                  "margin-top": "5px",
                  width: "80%",
                  padding: "0",
                  "list-style": "none",
                  float: "left"
                }
              },
              [_vm._v(_vm._s(_vm.popupList.doctorSuggestion))]
            )
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticStyle: { "padding-left": "calc(50% - 60px)" } }, [
      _c("input", {
        staticClass: "but",
        attrs: { type: "button", value: "立即打印" },
        on: {
          click: function($event) {
            _vm.print()
          }
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2cd23a74", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cd23a74","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/physical/physical_report.vue
// module id = null
// module chunks = 